import React from 'react'
import { useTranslation } from 'react-i18next'
import GaugeComponent from 'react-gauge-component'
import './gaugeTasksProgression.css'

const GaugeTasksProgression = (props) => {
  const { t } = useTranslation()

  const title = props.title
  const height = props.height
  const width = props.width
  const tasksCompleted = Math.floor(props.tasksCompleted * 100) / 100
  const tasksTotal = Math.floor(props.tasksTotal * 100) / 100

  const tasksTodo = Math.floor((tasksTotal - tasksCompleted) * 100) / 100

  // gaugeKey changes forces the component with that key to redraw! Occurs on widget resizing
  const gaugeKey = props.gaugeKey

  return (
    <div className='gaugeSemiCircle'>
      <div className='gaugeTitle'>{title}</div>
      {tasksTotal > 0 ? (
        <GaugeComponent
          key={gaugeKey}
          type='semicircle'
          style={{ height: height, width: width }}
          arc={{
            width: 0.2,
            padding: 0.005,
            cornerRadius: 1,
            subArcs: [
              {
                limit: tasksCompleted,
                color: 'rgb(181, 230, 29)',
                showTick: true,
                tooltip: {
                  text: t('9500021') + ': ' + tasksCompleted,
                },
              },
              {
                color: 'rgb(192,192,192)',
                tooltip: {
                  text: t('9500022') + ': ' + tasksTodo,
                },
              },
            ],
          }}
          pointer={{
            color: 'rgb(128, 128, 128)',
            length: 0.8,
            width: 15,
          }}
          labels={{
            valueLabel: {
              formatTextValue: (value) => Math.floor((value / tasksTotal) * 100) + '%',
              style: {
                fill: 'rgb(128, 128, 128)',
                fontSize: 'x-large',
              },
            },
            tickLabels: {
              type: 'outer',
              valueConfig: {
                formatTextValue: (value) => value,
                fontSize: 10,
                style: { fill: 'black' },
              },
            },
          }}
          value={tasksCompleted}
          minValue={0}
          maxValue={tasksTotal}
        />
      ) : (
        <div className='nodata'>{t('9500106')}</div>
      )}
    </div>
  )
}

export default GaugeTasksProgression
